// extracted by mini-css-extract-plugin
module.exports = {"container":"TransactionModuleBase_container__EIpMD"};